import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import ArticlePage from "@/pages/ArticlePage";
import GuidesPage from "@/pages/GuidesPage";
import GuidePage from "@/pages/GuidePage";
import ValuesPage from "@/pages/ValuesPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PillarGuidePage from "@/pages/PillarGuidePage";
import ValueCardPage from "@/pages/ValueCardPage";
import StartersHubPage from "@/pages/StartersHubPage";
import StarterGuidePage from "@/pages/StarterGuidePage";
import { CookieBanner } from "@/components/CookieBanner";

// Pagine non indicizzate o rare: fuori dal bundle iniziale, così le pagine
// editoriali (e il prerender per i crawler) caricano meno JavaScript.
const SearchPage = lazy(() => import("@/pages/SearchPage"));
const UnsubscribePage = lazy(() => import("@/pages/UnsubscribePage"));
const DisclaimerPage = lazy(() => import("@/pages/DisclaimerPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const CookiePage = lazy(() => import("@/pages/CookiePage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const LegalNoticePage = lazy(() => import("@/pages/LegalNoticePage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function AdminGate() {
  const { admin, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white font-meta text-sm">Caricamento…</div>;
  return admin ? <AdminDashboard /> : <AdminLogin />;
}

function PublicLayout({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-ink" />}>
          <Routes>
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/categoria/:slug" element={<PublicLayout><CategoryPage /></PublicLayout>} />
            <Route path="/articolo/:slug" element={<PublicLayout><ArticlePage /></PublicLayout>} />
            <Route path="/guide" element={<PublicLayout><GuidesPage /></PublicLayout>} />
            <Route path="/guida/:slug" element={<PublicLayout><GuidePage /></PublicLayout>} />
            <Route path="/valori" element={<PublicLayout><ValuesPage /></PublicLayout>} />
            <Route path="/cerca" element={<PublicLayout><SearchPage /></PublicLayout>} />
            <Route path="/disclaimer" element={<PublicLayout><DisclaimerPage /></PublicLayout>} />
            <Route path="/disiscriviti" element={<PublicLayout><UnsubscribePage /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><PrivacyPage /></PublicLayout>} />
            <Route path="/collezionismo" element={<PublicLayout><PillarGuidePage /></PublicLayout>} />
            <Route path="/valori/:slug" element={<PublicLayout><ValueCardPage /></PublicLayout>} />
            <Route path="/come-iniziare" element={<PublicLayout><StartersHubPage /></PublicLayout>} />
            <Route path="/come-iniziare/:category" element={<PublicLayout><StarterGuidePage /></PublicLayout>} />
            <Route path="/cookie" element={<PublicLayout><CookiePage /></PublicLayout>} />
            <Route path="/termini" element={<PublicLayout><TermsPage /></PublicLayout>} />
            <Route path="/note-legali" element={<PublicLayout><LegalNoticePage /></PublicLayout>} />
            <Route path="/chi-siamo" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/admin" element={<AdminGate />} />
            <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
          </Routes>
          </Suspense>
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
